import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface EmptyStateMessageProps {
  icon?: ReactNode;
  title: string;
  titleSx?: SxProps<Theme>;
  message: string;
  action?: ReactNode;
  spacing?: number;
}

export default function EmptyStateMessage({
  icon = <AccessTimeOutlined fontSize="large" color="disabled" />,
  title,
  titleSx,
  message,
  action,
  spacing = 1,
}: EmptyStateMessageProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        p: 4,
      }}
    >
      <Stack spacing={spacing} alignItems="center" maxWidth={400}>
        {icon}
        <Typography variant="h6" sx={{ fontWeight: 'bold', ...titleSx }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
        {action && <Box sx={{ mt: spacing }}>{action}</Box>}
      </Stack>
    </Box>
  );
}
